import { Flex, styled, css } from '@chilipiper/design-system'

const activeStyle = css`
  box-shadow: ${props => props.theme.shadows['border/list-item-selected']};
  background: ${props => props.theme.colors['bg/list-item-selected']};
`

export const StyledBlock = styled(Flex)<{ active?: boolean }>`
  ${props => props.active && activeStyle}

  &:hover {
    ${activeStyle}
  }
`
